import * as React from 'react';
import { t } from 'i18next';

import { DownloadOption } from '../stores/AppConfigurationStore';
import { LongButton, LongButtonProps } from './LongButton';

interface DownloadButtonProps {
    option: DownloadOption;
    callback: (value: ExportFormat) => void;
    toggled?: boolean;
    hideArrow?: boolean;
}

export class DownloadButton extends React.PureComponent<DownloadButtonProps> {
    public render(): JSX.Element | null {
        if (!this.props.option.visible) {
            return null;
        }
        if (this.props.option.disabled) {
            return (
                <LongButton {...this.getButtonProps()} disabled={true}>{this.getLabel(this.props.option.type)}</LongButton>
            );
        }
        return (
            <LongButton {...this.getButtonProps()} onClick={this.onClick}>
                {this.getLabel(this.props.option.type)}
            </LongButton>
        );
    }

    protected onClick = (): void => {
        this.props.callback(this.props.option.type);
    };

    protected getLabel(value: ExportFormat): string {
        switch (value) {
            case 'PDF':
                return t('Article List') + ' (PDF)';
            case 'EXCEL':
                return t('Article List') + ' (Excel)';
            default:
                break;
        }
        return value;
    }

    protected getButtonProps(): LongButtonProps {
        const result: LongButtonProps = {
            shortBorder: true
        };
        if (this.props.toggled == null) {
            result.icon = 'dl-button';
        } else {
            result.toggled = this.props.toggled;
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DownloadButton.tsx